import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42d7933c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile-stats-row" }
const _hoisted_2 = { class: "profile-stat-card" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profile-stat-icon-circle" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trophy-fill" })
], -1))
const _hoisted_4 = { class: "profile-stat-value" }
const _hoisted_5 = { class: "profile-stat-label" }
const _hoisted_6 = { class: "profile-stat-caption" }
const _hoisted_7 = { class: "profile-stat-card" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profile-stat-icon-circle" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-globe" })
], -1))
const _hoisted_9 = { class: "profile-stat-value" }
const _hoisted_10 = { class: "profile-stat-label" }
const _hoisted_11 = { class: "profile-stat-caption" }
const _hoisted_12 = { class: "profile-stat-card" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profile-stat-icon-circle" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-droplet-fill" })
], -1))
const _hoisted_14 = { class: "profile-stat-value" }
const _hoisted_15 = { class: "profile-stat-label" }
const _hoisted_16 = { class: "profile-stat-caption" }
const _hoisted_17 = { class: "profile-stat-card" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profile-stat-icon-circle" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-cpu-fill" })
], -1))
const _hoisted_19 = { class: "profile-stat-value" }
const _hoisted_20 = { class: "profile-stat-label" }
const _hoisted_21 = { class: "profile-stat-caption" }
const _hoisted_22 = { class: "profile-stat-card" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profile-stat-icon-circle" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-flag-fill" })
], -1))
const _hoisted_24 = { class: "profile-stat-value" }
const _hoisted_25 = { class: "profile-stat-label" }
const _hoisted_26 = { class: "profile-stat-caption" }
const _hoisted_27 = { class: "profile-stat-card" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profile-stat-icon-circle" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-lightning-charge-fill" })
], -1))
const _hoisted_29 = { class: "profile-stat-value" }
const _hoisted_30 = { class: "profile-stat-label" }
const _hoisted_31 = { class: "profile-stat-caption" }


export default /*#__PURE__*/_defineComponent({
  props: {
    scoreboardPosition: null,
    scoreboardGlobalPosition: null,
    totalFirstBloods: null,
    machinesCompleted: null,
    totalMachines: null,
    challengesCompleted: null,
    totalChallenges: null,
    streakCurrent: null,
    rankCompetitiveLabel: null,
    rankGlobalLabel: null,
    firstBloodLabel: null,
    machinesCompletedLabel: null,
    challengesCompletedLabel: null,
    streakLabel: null,
    globalSuffix: null,
    conquestsSuffix: null,
    labsSuffix: null,
    challengesSuffix: null,
    daysSuffix: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, _toDisplayString(__props.scoreboardPosition ?? "-") + "°", 1),
      _createElementVNode("div", _hoisted_5, _toDisplayString(__props.rankCompetitiveLabel), 1),
      _createElementVNode("div", _hoisted_6, _toDisplayString(__props.globalSuffix), 1)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, _toDisplayString(__props.scoreboardGlobalPosition ?? "-") + "°", 1),
      _createElementVNode("div", _hoisted_10, _toDisplayString(__props.rankGlobalLabel), 1),
      _createElementVNode("div", _hoisted_11, _toDisplayString(__props.globalSuffix), 1)
    ]),
    _createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      _createElementVNode("div", _hoisted_14, _toDisplayString(__props.totalFirstBloods), 1),
      _createElementVNode("div", _hoisted_15, _toDisplayString(__props.firstBloodLabel), 1),
      _createElementVNode("div", _hoisted_16, _toDisplayString(__props.conquestsSuffix), 1)
    ]),
    _createElementVNode("div", _hoisted_17, [
      _hoisted_18,
      _createElementVNode("div", _hoisted_19, _toDisplayString(__props.machinesCompleted) + " / " + _toDisplayString(__props.totalMachines), 1),
      _createElementVNode("div", _hoisted_20, _toDisplayString(__props.machinesCompletedLabel), 1),
      _createElementVNode("div", _hoisted_21, _toDisplayString(__props.labsSuffix), 1)
    ]),
    _createElementVNode("div", _hoisted_22, [
      _hoisted_23,
      _createElementVNode("div", _hoisted_24, _toDisplayString(__props.challengesCompleted) + " / " + _toDisplayString(__props.totalChallenges), 1),
      _createElementVNode("div", _hoisted_25, _toDisplayString(__props.challengesCompletedLabel), 1),
      _createElementVNode("div", _hoisted_26, _toDisplayString(__props.challengesSuffix), 1)
    ]),
    _createElementVNode("div", _hoisted_27, [
      _hoisted_28,
      _createElementVNode("div", _hoisted_29, _toDisplayString(__props.streakCurrent ?? 0), 1),
      _createElementVNode("div", _hoisted_30, _toDisplayString(__props.streakLabel), 1),
      _createElementVNode("div", _hoisted_31, _toDisplayString(__props.daysSuffix), 1)
    ])
  ]))
}
}

})